import { PeopleQueryBaseDto } from './people-query-base.dto';
import { PeopleEmployeePersonalDetailsDto } from './employee';

export class PeopleGenderDto {
  id: number;
  gender: string;

  employeePersonalDetails?: PeopleEmployeePersonalDetailsDto[];
}

export interface PeopleGenderQueryDto extends PeopleQueryBaseDto {
  gender?: string;
}
